import { orchestrator } from 'satcheljs';
import { owaConnectedAccountAdded } from 'owa-account-store-init';
import refreshReminders from '../actions/refreshReminders';

/**
 * starts the initial reminder load for the account that has been just initialized
 */
orchestrator(owaConnectedAccountAdded, actionMessage => {
    refreshReminders(actionMessage.accountSmtpAddress);
});
